import { render } from "./GlobalAudio.vue?vue&type=template&id=7f8e6805"
import script from "./GlobalAudio.vue?vue&type=script&lang=js"
export * from "./GlobalAudio.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__